/* eslint-disable @typescript-eslint/no-explicit-any */
export default (e: any) => e
